<template>
  <a-drawer
    :title="notficationTitle"
    :width="720"
    :visible="visible"
    @close="onClose"
    :destroyOnClose="true"
    wrapClassName="notification-wrapper"
  >
    <DetailAdditionalTimesheet :id="getId()" v-if="showAdditionalDetail()" />
    <ApprovalAdditionalTimesheet
      :id="getId()"
      v-if="showAdditionalApprovalDetail()"
    />
    <DetailOverTimeRequest :id="getId()" v-if="showOverTimeRequestDetail()" />
    <DetailRemoteRequest :id="getId()" v-if="showRemoteRequestDetail()" />
    <ApprovalRemoteRequestDetail
      :id="getId()"
      v-if="showApprovalRemoteRequestDetail()"
    />
  </a-drawer>
</template>
<script>
import DetailAdditionalTimesheet from "../../views/AdditionalTimesheet/DetailAdditionalTimesheet.vue";
import DetailOverTimeRequest from "../../views/OverTimeRequests/DetailOverTimeRequest.vue";
import DetailRemoteRequest from "../../views/RemoteRequest/RemoteDrawer/DetailRemoteRequest.vue";
import ApprovalRemoteRequestDetail from "../../views/RemoteRequest/RemoteDrawer/ApprovalRemoteRequestDetail.vue";
import ApprovalAdditionalTimesheet from "../../views/AdditionalTimesheet/ApprovalAdditionalTimesheet.vue";

export default {
  name: "NotificationDrawer",
  props: {
    notification: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    notficationTitle() {
      let title = "";
      if (this.notification?.type == "ADDITIONAL_TIMESHEET") {
        title = this.$t("commons.label_header_approval_addtimesheet");
      }
      if (this.notification?.type == "OVERTIME_REQUEST") {
        title = this.$t("commons.label_header_approval");
      }
      if (this.notification?.type == "REMOTE_WORKING_REQUEST") {
        title = this.$t("commons.label_header_approval_remote");
      }
      return title;
    },
  },
  components: {
    DetailAdditionalTimesheet,
    DetailOverTimeRequest,
    ApprovalAdditionalTimesheet,
    ApprovalRemoteRequestDetail,
    DetailRemoteRequest

  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    getId() {
      return this.notification?.request_id;
    },
    showAdditionalDetail() {
      return (
        this.notification?.type == "ADDITIONAL_TIMESHEET" &&
        this.notification?.request_type == "APPROVED"
      );
    },
    showAdditionalApprovalDetail() {
      return (
        this.notification?.type == "ADDITIONAL_TIMESHEET" &&
        this.notification?.request_type == "REQUEST"
      );
    },
    showOverTimeRequestDetail() {
      return this.notification?.type == "OVERTIME_REQUEST";
    },
     showRemoteRequestDetail() {
      return (
        this.notification?.type == "REMOTE_WORKING_REQUEST" &&
        this.notification?.request_type == "APPROVED"
    )},
    showApprovalRemoteRequestDetail() {
      return (
        this.notification?.type == "REMOTE_WORKING_REQUEST" &&
        this.notification?.request_type == "REQUEST"
    )},
  },
};
</script>
<style lang="scss">
.ant-drawer.ant-drawer-right.ant-drawer-open {
  z-index: 1030;
}
.notification-wrapper {
  .ant-drawer-header {
    background-color: #d2d6ff;
    border-bottom-color: #3d4cdc;
    .ant-drawer-title {
      color: #3d4cdc;
      font-weight: 500;
      font-size: 16px;
    }
    .ant-drawer-close:focus {
      outline: none;
    }
  }
  .ant-drawer-body {
    max-height: calc(100vh - 55px);
    overflow-y: auto;
  }
}
</style>
<style lang="scss" scoped>
</style>
